import { Grid2 } from "@mui/material";
import React from "react";
import CompanySection from "./CompanySection";
import ContactSection from "./ContactSection";

const InfoSection = () => {
    return (
        (<Grid2 container  alignContent={"flex-start"} justify={"flex-start"} spacing={2} size={12}>
            <Grid2 size={12}>
                <CompanySection />
            </Grid2>
            <Grid2 size={12}>
                <ContactSection />
            </Grid2>
        </Grid2>)
    );
};

export default InfoSection;
